import { Close } from '@mui/icons-material';
import { Alert, Fade, IconButton, Snackbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { markMessageAsSeen, messageSelector } from 'redux/reducers/messages';
import { useAppDispatch } from 'redux/store';
import { GlobalMessage } from 'utils';

const FlashNotifications = () => {
    const dispatch = useAppDispatch();
    const { data } = useSelector(messageSelector);
    const [currentMessage, setCurrentMessage] = useState<null | GlobalMessage>(null);

    useEffect(() => {
        setCurrentMessage(data[0] || null);
    }, [data]);

    const showNextAvailableMessage = () => {
        if (currentMessage) {
            dispatch(markMessageAsSeen(currentMessage));
        }
    };

    if (!currentMessage || !currentMessage.message) {
        return null;
    }

    // Ensure message is a string
    const messageText =
        typeof currentMessage.message === 'string'
            ? currentMessage.message
            : typeof currentMessage.message === 'object'
            ? JSON.stringify(currentMessage.message)
            : String(currentMessage.message || '');

    // Safely get action properties
    const actionText =
        currentMessage.action &&
        typeof currentMessage.action === 'object' &&
        'actionText' in currentMessage.action &&
        typeof currentMessage.action.actionText === 'string'
            ? currentMessage.action.actionText
            : null;

    const actionLink =
        currentMessage.action &&
        typeof currentMessage.action === 'object' &&
        'actionLink' in currentMessage.action &&
        typeof currentMessage.action.actionLink === 'string'
            ? currentMessage.action.actionLink
            : '#';

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            onClose={showNextAvailableMessage}
            autoHideDuration={6000}
            open={true}
            TransitionComponent={Fade}
            key={currentMessage.uuid}
            action={
                <React.Fragment>
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={showNextAvailableMessage}
                    >
                        <Close />
                    </IconButton>
                </React.Fragment>
            }
        >
            <Alert onClose={showNextAvailableMessage} severity={currentMessage.status}>
                <div>
                    {messageText}
                    {actionText && (
                        <>
                            {' '}
                            <a target="_blank" rel="noreferrer" href={actionLink}>
                                {actionText}
                            </a>
                        </>
                    )}
                </div>
            </Alert>
        </Snackbar>
    );
};

export default FlashNotifications;
